import { render } from "./ModalEndOrder.vue?vue&type=template&id=176e48b8"
import script from "./ModalEndOrder.vue?vue&type=script&lang=js"
export * from "./ModalEndOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__